exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pv0EfmcYRH5ZG1Jx5JhaV{height:0;width:0}", ""]);
// Exports
exports.locals = {
	"printIframe": "pv0EfmcYRH5ZG1Jx5JhaV"
};